<template>
  <!-- The same segmented control as the language, beside it in the user menu:
       three options fit, and the current one shows without opening anything. -->
  <div class="themes" role="group" :aria-label="t('nav.themeLabel')">
    <button
      v-for="option in OPTIONS"
      :key="option"
      type="button"
      class="themes__item"
      :class="{ 'themes__item--active': preference === option }"
      :aria-pressed="preference === option"
      @click="setPreference(option)"
    >
      <AppIcon :name="THEME_ICONS[option]" :size="13" />
      {{ t(`nav.themes.${option}`) }}
    </button>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useTheme, THEME_PREFERENCES as OPTIONS } from '@general/ui-kit'
import AppIcon from './AppIcon.vue'
import { THEME_ICONS } from '../app/themeIcons'

const { t } = useI18n()
const { preference, setPreference } = useTheme()
</script>

<style scoped>
.themes {
  display: flex;
  gap: 2px;
  padding: 2px;
  background: var(--color-gray-100);
  border-radius: var(--radius-sm);
}

.themes__item {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px 6px;
  border: none;
  border-radius: 4px;
  background: none;
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-soft);
  white-space: nowrap;
  transition: background var(--fast), color var(--fast);
}
.themes__item:hover { color: var(--color-text); }

.themes__item--active {
  background: var(--color-surface);
  color: var(--color-primary);
  box-shadow: var(--shadow-sm);
}
</style>
